import TimetableSerializer from './base';

export default class Structure extends TimetableSerializer {}
